package com.downdogapp.client

import com.downdogapp.client.api.AppType
import com.downdogapp.client.resources.Image
import com.downdogapp.client.resources.Images

val AppType.displayName: String
  get() = when (this) {
    AppType.ORIGINAL -> Strings.YOGA
    AppType.INTRO -> Strings.YOGA_FOR_BEGINNERS
    AppType.HIIT -> Strings.HIIT
    AppType.BARRE -> Strings.BARRE
    AppType.SEVEN -> Strings.SEVEN_MINUTE
    AppType.PRENATAL -> Strings.PRENATAL
    AppType.MEDITATION -> Strings.MEDITATION
    AppType.RUNNING -> Strings.RUNNING
    AppType.BREATHING -> Strings.BREATHING
    AppType.PILATES -> Strings.PILATES
  }

val AppType.shortDisplayName: String
  get() = when (this) {
    AppType.ORIGINAL -> Strings.YOGA
    AppType.INTRO -> Strings.YOGA_FOR_BEGINNERS
    AppType.HIIT -> Strings.HIIT
    AppType.BARRE -> Strings.BARRE
    AppType.SEVEN -> Strings.SEVEN_MINUTE
    AppType.PRENATAL -> Strings.PRENATAL_SHORT
    AppType.MEDITATION -> Strings.MEDITATION
    AppType.RUNNING -> Strings.RUNNING
    AppType.BREATHING -> Strings.BREATHING
    AppType.PILATES -> Strings.PILATES
  }

val AppType.icon: Image // 50px icon
  get() = when (this) {
    AppType.ORIGINAL -> Images.MENU_LINK_ORIGINAL
    AppType.INTRO -> Images.MENU_LINK_INTRO
    AppType.HIIT -> Images.MENU_LINK_HIIT
    AppType.BARRE -> Images.MENU_LINK_BARRE
    AppType.SEVEN -> Images.MENU_LINK_SEVEN
    AppType.PRENATAL -> Images.MENU_LINK_PRENATAL
    AppType.MEDITATION -> Images.MENU_LINK_MEDITATION
    AppType.RUNNING -> Images.MENU_LINK_RUNNING
    AppType.BREATHING -> Images.MENU_LINK_BREATHING
    AppType.PILATES -> Images.MENU_LINK_PILATES
  }

val AppType.badgeIcon: Image // 16px icon
  get() = when (this) {
    AppType.ORIGINAL -> Images.HISTORY_LINK_ORIGINAL
    AppType.INTRO -> Images.HISTORY_LINK_INTRO
    AppType.HIIT -> Images.HISTORY_LINK_HIIT
    AppType.BARRE -> Images.HISTORY_LINK_BARRE
    AppType.SEVEN -> Images.HISTORY_LINK_SEVEN
    AppType.PRENATAL -> Images.HISTORY_LINK_PRENATAL
    AppType.MEDITATION -> Images.HISTORY_LINK_MEDITATION
    AppType.RUNNING -> Images.HISTORY_LINK_RUNNING
    AppType.BREATHING -> Images.HISTORY_LINK_BREATHING
    AppType.PILATES -> Images.HISTORY_LINK_PILATES
  }

val BULLET_UNICODE = "•︎"

expect object Util {

  val isSmallPhone: Boolean
  val safeAreaTopMargin: Double
  val safeAreaBottomMargin: Double
}
